import React from 'react';
import AboutService from '@mos-front-components/public/es/components/AboutService';

import st from './AboutServiceBtn.module.css';

const AboutServiceBtn = () => (
  <AboutService titleToggle="О сервисе" onClick={() => {}}>
    <div className={st.columnText}>
      <div className={st.title}>О сервисе</div>
      <p>
        Сервис позволяет записаться на&nbsp;прием в&nbsp;Центры госуслуг города
        Москвы. Найти ближайший к&nbsp;дому или работе Центр госуслуг можно
        на&nbsp;карте. Доступна фильтрация по&nbsp;районам, станциям метро
        и&nbsp;предоставляемым услугам.
      </p>
      <p>
        На&nbsp;странице Центра госуслуг представлено расписание его работы
        и&nbsp;график загруженности, список ближайших станций метро. Также можно
        посмотреть адрес, контактный телефон и&nbsp;список предоставляемых
        услуг.
      </p>
    </div>
  </AboutService>
);

export default AboutServiceBtn;
